module.exports = __webpack_public_path__ + "img/bit.ly.png";